// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"termsAndCond_mainContainer__fxvcK","moreHelp":"termsAndCond_moreHelp__W3UJY"};